import { InputPrefix, InputSuffix, TextBox } from '@progress/kendo-react-inputs';
import React, { useState } from 'react';
import { useSearchContext } from '../../../../context/search/SearchContext';
import { useViewsContext } from '../../../../context/view/ViewsContext';
import { SvgIcon } from '@progress/kendo-react-common';
import { searchIcon, arrowLeftIcon } from '@progress/kendo-svg-icons';
import { EMPTY_VALUE } from '../../../../config/consts';
import { GEAR_FIELD_TYPE } from '../../../../global/enums/GearFieldType';
import { useDocumentsContext } from '../../../../context/documents/DocumentsContext';
import { useGlobalizationContext } from '../../../../context/globalization/GlobalizationContext';
import { useGetView } from '../../../../context/view/useGetView';
import { useTranslation } from '../../../../context/globalization/useTranslation';

export const GlobalSearchFilter: React.FC = () => {
  const { queryRequest, setQueryRequest } = useSearchContext();
  const { setSelectedDocuments } = useDocumentsContext();
  const { views } = useViewsContext();
  const { selectedLocale } = useGlobalizationContext();
  const [tempSearchPhrase, setTempSearchPhrase] = useState<string>(EMPTY_VALUE);
  const { translate } = useTranslation(selectedLocale);

  const defaultViewId = views?.find(view => view.isDefault)?.id;
  const { data: defaultView } = useGetView(defaultViewId, selectedLocale);

  const handleSearch = (newSearchPhrase: string) => {
    if (!queryRequest || !setQueryRequest || !defaultView?.fields) {
      return;
    }

    const trimmedSearchPhrase = newSearchPhrase.trim();

    setQueryRequest({
      ...queryRequest,
      searchFields: defaultView.fields.filter(field => field.type !== GEAR_FIELD_TYPE.DATE).map(field => field.name),
      searchText: trimmedSearchPhrase !== EMPTY_VALUE ? trimmedSearchPhrase : undefined
    });

    setTempSearchPhrase(trimmedSearchPhrase);
    if (setSelectedDocuments) {
      setSelectedDocuments([]);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch(tempSearchPhrase);
    }
  };

  return (
    <>
      {queryRequest && (
        <TextBox
          id={'global-search-filter'}
          className="globalSearchFilter"
          placeholder={translate('custom.topBar.globalSearch')}
          defaultValue={queryRequest.searchText}
          value={tempSearchPhrase}
          onChange={e => setTempSearchPhrase(e.target.value !== undefined ? e.target.value?.toString() : '')}
          onKeyDown={handleKeyPress}
          fillMode={'outline'}
          autoComplete="off"
          prefix={() => (
            <>
              <InputPrefix>
                <SvgIcon
                  className={tempSearchPhrase !== EMPTY_VALUE ? `globalSearchFilter--reset` : ''}
                  icon={tempSearchPhrase !== EMPTY_VALUE ? arrowLeftIcon : searchIcon}
                  onClick={() => handleSearch(EMPTY_VALUE)}
                />
              </InputPrefix>
            </>
          )}
          suffix={() => (
            <>
              {tempSearchPhrase !== EMPTY_VALUE && (
                <>
                  <InputSuffix>
                    <SvgIcon
                      className="globalSearchFilter--search"
                      enableBackground={1}
                      icon={searchIcon}
                      onClick={() => handleSearch(tempSearchPhrase)}
                    />
                  </InputSuffix>
                </>
              )}
            </>
          )}
        />
      )}
    </>
  );
};
